<!--
* UIID: UI-DLB-RMG-100
* UI Name: Repository_Manager
* Modify Date: 2020/07/07
-->

<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.repositoryManager.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Tab control -->
    <v-row class="page-tab">
      <v-col class="pt-0" cols="12">
        <v-tabs
          @change="changeTab"
          class="custom-tab-bar"
          background-color="primary"
          v-model="tab"
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
          >
            {{ item.content }}
          </v-tab>
        </v-tabs>
        <v-tabs-items class="custom-tab-content" v-model="tab">
          <v-tab-item 
            :key="'repository'"
            no-animation
          >
            <Repository
              :changeTab="repositoryCompo"
            >
            </Repository>
          </v-tab-item>
          <v-tab-item
            :key="'srm_list'"
            no-animation
          >
            <SRMList
              :changeTab="srm_listCompo"
            >
            </SRMList>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>      
  </div>
</template>

<script>

import Repository from './Repository.vue'
import SRMList from './SRMList.vue'

export default {
  components: {
    Repository,
    SRMList
  },  
  data: () => ({
    repositoryCompo:0,
    srm_listCompo:0,
    tab: null,
    items: [
      { tab: 'repository', content: 'Repository' },
      { tab: 'srm_list', content: 'SRM List' },
    ],
  }),

  created() {    
  },
  mounted() {    
  },
  watch: {
  },

  methods: {   
    changeTab(){
      this.repositoryCompo +=1;
      this.srm_listCompo +=1;
    } 
  },
}
</script>

<style>
  
</style>